import {InputLabel} from "@/components/inputs";
import {Button} from "@/components/buttons";
import React from "react";

import {ButtonProps, PropsInput} from "@/components/props";
import {observer} from "mobx-react-lite";
import {useEnterKeydown, useFormikConfig} from "../hooks";
import {IRegData} from "@/types/auth";
import {RegData} from "@/models/auth";
import {useStore} from "@/store";
import {onSubmitRegData} from "@/pages/login/submits";


export const RegDataForm = observer(() => {
    const {formActiveStore: {setFormActive}} = useStore()
    const [isFocus, setIsFocus] = React.useState<boolean>(false);

    const onSubmit = () => onSubmitRegData(formik, setFormActive);
    const initialValues: IRegData = new RegData()
    const validationSchema = (initialValues as RegData).validationSchema();
    const formik = useFormikConfig<IRegData>(initialValues, onSubmit, validationSchema);
    useEnterKeydown(isFocus, onSubmit, setIsFocus);


    const fNameProps: PropsInput = {
        type: 'text',
        name: 'f_name',
        label: 'Фамилия',
        error: formik.touched.f_name && formik.errors.f_name || '',
        placeholder: 'Введите вашу фамилию',
        colorError: 'red',
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.f_name,
        autoComplete: 'off',
    }
    const lNameProps: PropsInput = {
        ...fNameProps,
        name: 'l_name',
        label: 'Имя',
        error: formik.touched.l_name && formik.errors.l_name || '',
        placeholder: 'Введите ваше имя',
        value: formik.values.l_name,


    }
    const pNameProps: PropsInput = {
        ...fNameProps,
        name: 'p_name',
        label: 'Отчество',
        error: formik.touched.p_name && formik.errors.p_name || '',
        placeholder: 'Введите ваше отчество',
        value: formik.values.p_name,

    }
    const emailProps: PropsInput = {
        ...fNameProps,
        name: 'email',
        label: 'Email',
        error: formik.touched.email && formik.errors.email,
        placeholder: 'Введите ваш e-mail',
        value: formik.values.email,
        onFocus: () => setIsFocus(true)
    }
    const buttonProps: ButtonProps = {
        type: 'submit',
        disabled: !formik.isValid || formik.isSubmitting,

    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <InputLabel {...fNameProps}/>
            <InputLabel {...lNameProps}/>
            <InputLabel {...pNameProps}/>
            <InputLabel {...emailProps}/>
            <Button {...buttonProps}> Продолжить</Button>
        </form>
    )
})

export default RegDataForm;